/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import { Statistic, Divider, Form, Button, Dimmer, Loader } from 'semantic-ui-react';
import { fetchApi } from '@gasbuddy/react/build/fetchApi';
import moment from 'moment';
import BN from 'bignumber.js';
import DatePicker from 'react-datepicker';
import TimePicker from 'rc-time-picker';
import { Nav, Auth } from '../../components';
import { Role } from '../../roles';
import { QueryBuilder } from '../../components/queryBuilder';

const STATPAD = 80;

class BaseCoupon extends React.Component {
  state = {}

  saveEligibility = async () => {

  }

  assign = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { fromDate, toDate, usage, ids, fromTime, toTime } = this.state;
      const { couponId } = this.props;
      const { body } = await fetchApi({
        url: `/payments/coupons/${couponId}/assign`,
        body: {
          from: fromDate ? `${fromDate.format('YYYY-MM-DD')}T${fromTime.format('HH:mm:ss')}Z` : null,
          to: toDate ? `${toDate.format('YYYY-MM-DD')}T${toTime.format('HH:mm:ss')}Z` : null,
          uses: usage,
          ids,
        },
      });
      this.setState({ loading: false, ids: body.remaining.join('\n') });
    });
  }

  clear(f) {
    return (e) => {
      e.preventDefault();
      this.setState({
        [`${f}Date`]: null,
        [`${f}Time`]: null,
      });
    };
  }

  render() {
    const { data: coupon = {} } = this.props;
    let { eligibility } = coupon;
    if (eligibility && Object.keys(eligibility).length === 0) {
      eligibility = null;
    }
    const { loading, fromDate, fromTime, toDate, toTime, ids } = this.state;

    return (
      <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
        <Nav>
          <h1>Coupon Details</h1>
          <div style={{ textAlign: 'center' }}>
            <Statistic style={{ paddingRight: STATPAD }}>
              <Statistic.Value>{coupon.assignments}</Statistic.Value>
              <Statistic.Label>Accounts w/Coupon</Statistic.Label>
            </Statistic>
            <Statistic style={{ paddingRight: STATPAD, paddingLeft: STATPAD }}>
              <Statistic.Value>{coupon.account_count}</Statistic.Value>
              <Statistic.Label>Accounts Used Coupon</Statistic.Label>
            </Statistic>
            <Statistic style={{ paddingRight: STATPAD, paddingLeft: STATPAD }}>
              <Statistic.Value>{coupon.split_count}</Statistic.Value>
              <Statistic.Label>Transactions</Statistic.Label>
            </Statistic>
            <Statistic style={{ paddingLeft: STATPAD }}>
              <Statistic.Value>
$
                {new BN(coupon.amount_awarded || 0).toFixed(2)}
              </Statistic.Value>
              <Statistic.Label>Total Awarded</Statistic.Label>
            </Statistic>
          </div>
          <Divider />
          <b>Internal Name:</b>
          {' '}
          {coupon.internal_name}
          <br />
          <b>Name:</b>
          {' '}
          {coupon.name}
          <br />
          <b>Created:</b>
          {' '}
          {moment(coupon.created_at).format()}
          <br />

          <h2>Coupon Eligibility</h2>
          <QueryBuilder
            kind={QueryBuilder.Coupon}
            defaultValue={eligibility}
            save={this.saveEligibility}
          />

          <Divider />
          <h2>Assign Coupon To Users</h2>

          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>

            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  label="Usage Limit"
                  type="number"
                  width={3}
                  placeholder="(optional)"
                  onChange={(e, { value }) => this.setState({ usage: value })}
                />
                <Form.Field>&nbsp;</Form.Field>
              </Form.Group>
              <Form.Group width="equal">
                <Form.Field>
                  <label htmlFor="fromDate">Valid From</label>
                  <DatePicker
                    id="fromDate"
                    className="datetime"
                    selected={fromDate}
                    onChange={v => this.setState({ fromDate: v })}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="fromTime">(@ UTC time)</label>
                  <TimePicker
                    id="fromTime"
                    className="datetime"
                    value={fromTime}
                    onChange={v => this.setState({ fromTime: v })}
                  />
                </Form.Field>
                <Form.Button label="&nbsp;" onClick={this.clear('from')}>Clear</Form.Button>
                <Form.Field>
                  <label htmlFor="toDate">Valid Until</label>
                  <DatePicker
                    id="toDate"
                    className="datetime"
                    selected={toDate}
                    onChange={v => this.setState({ toDate: v })}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="toTime">(@ UTC time)</label>
                  <TimePicker
                    id="toTime"
                    className="datetime"
                    value={toTime}
                    onChange={v => this.setState({ toTime: v })}
                  />
                </Form.Field>
                <Form.Button label="&nbsp;" onClick={this.clear('to')}>Clear</Form.Button>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.TextArea
                  label="Emails or Account Ids"
                  rows={20}
                  value={ids}
                  onChange={(e, { value }) => this.setState({ ids: value })}
                />
              </Form.Group>
              <Button onClick={this.assign}>Assign</Button>
            </Form>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseCoupon.propTypes = {
  data: PT.shape({
    internal_name: PT.string,
  }).isRequired,
  couponId: PT.number.isRequired,
};

export const Coupon = withRouter(({ match }) => (
  <WithData url={`/payments/coupons/${match.params.couponId}`}>
    <BaseCoupon
      couponId={Number(match.params.couponId)}
    />
  </WithData>
));
